var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M5.425 1.654 16 12.229 26.565 1.664c1.85.989 3 2.544 3.687 3.856L19.772 16l10.47 10.47c-.68 1.31-1.822 2.875-3.667 3.876L16 19.77 5.426 30.346C3.58 29.345 2.438 27.78 1.759 26.47L12.229 16 1.759 5.53c.68-1.31 1.82-2.875 3.666-3.876Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M27.157 2.014c.59.385 1.1.827 1.537 1.292L16.943 15.057l-1.415-1.414 11.63-11.629ZM3.307 3.307l11.75 11.75-1.414 1.414L2.097 4.925a9.801 9.801 0 0 1 1.21-1.618Zm26.596 23.768a9.798 9.798 0 0 1-1.21 1.617l-11.75-11.75 1.414-1.413 11.546 11.546ZM4.836 29.992a8.409 8.409 0 0 1-1.529-1.3l11.75-11.75 1.414 1.415L4.836 29.992Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M20 .182v31.646A55.79 55.79 0 0 1 16 32a53.715 53.715 0 0 1-4-.18V.18A53.677 53.677 0 0 1 16 0a52.92 52.92 0 0 1 4 .182Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016A35.014 35.014 0 0 1 31.822 20H.166a36.282 36.282 0 0 1-.163-4.017A35.024 35.024 0 0 1 .178 12Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18.667.087v31.83c-.877.048-1.774.075-2.667.083a55.946 55.946 0 0 1-2.666-.087V.086C14.21.036 15.107.008 16 0c.893.008 1.79.037 2.667.087Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.069 13.333h31.87c.053.92.069 1.82.058 2.683.01.85-.009 1.738-.066 2.65H.061a38.244 38.244 0 0 1-.058-2.683c-.01-.85.009-1.737.066-2.65Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagGbr = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagGbr_default = SvgFlagGbr;
export {
  FlagGbr_default as default
};
